import { Box, Card, Modal } from "@mui/material";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// import { colorScheme } from 'default';
import React from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  height: 500,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};
function ViewDocument({ ...props }) {
  return (
    <Modal
      className="document-preview-overlay"
      open={props.open}
      onClose={props.closeModalClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card sx={style}>
        <Box>
          <IconButton
            aria-label="close"
            onClick={props.closeModalClick}
            sx={{
              position: "absolute",
              right: 0,
              top: 0,
              color: "grey",
            }}
          >
            <CloseIcon />
          </IconButton>
          <iframe
            src={props.fileName}
            height={400}
            width={700}
            title="View"
          ></iframe>
        </Box>
      </Card>
    </Modal>
  );
}

export default ViewDocument;
